<div
	class="dialog-content"
	data-qa="icon-dialog"
>
	<div class="icon">
		<app-icon
			[icon]="iconName"
			iconSize="84"
			iconTheme="dark"
		></app-icon>
	</div>
</div>
